import { render, staticRenderFns } from "./IndustryScoreAnalysisTable.vue?vue&type=template&id=a5a7f9aa&scoped=true&"
import script from "./IndustryScoreAnalysisTable.vue?vue&type=script&lang=ts&"
export * from "./IndustryScoreAnalysisTable.vue?vue&type=script&lang=ts&"
import style0 from "./IndustryScoreAnalysisTable.vue?vue&type=style&index=0&id=a5a7f9aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a7f9aa",
  null
  
)

export default component.exports